import { type FC } from 'react'

import { Breadcrumb, Breadcrumbs, Link } from '@redteclab/web-ui-react'

import { apmCaptureError, apmSetCustomContext } from '../../../apm'
import { type SeoBreadcrumbListItem } from '../../../seo'
import { useProductPageContext } from '../productPageContext'

const getBreadcrumbItem = (
  breadcrumbItem: SeoBreadcrumbListItem,
): { link?: string; name: string } | null => {
  const { item: link, name } = breadcrumbItem

  if (typeof name === 'string') {
    if (typeof link === 'string') {
      return { link, name }
    }

    return { name }
  }
  apmSetCustomContext({
    breadcrumbItem,
  })

  apmCaptureError(
    new Error('Breadcrumb item has a wrong format for experiment'),
  )

  return null
}

/**
 * Breadcrumbs have home, category list and product itself:
 *
 * - Home
 * - Category 1
 * - Category 2
 * - ...
 * - Product name
 *
 * Make sense to show breadcrumbs when you have at least 1 category, because product won't be displayed.
 */
const MIN_VISIBLE_BREADCRUMBS = 3

export const ProductBreadcrumbs: FC = () => {
  const { breadcrumbs } = useProductPageContext()

  const items = breadcrumbs
    ?.map((breadcrumb) => getBreadcrumbItem(breadcrumb))
    .filter((item) => item !== null)

  if (!items || items.length < MIN_VISIBLE_BREADCRUMBS) {
    return null
  }

  return (
    <div className="container py-3">
      <Breadcrumbs items={items.slice(0, -1)}>
        {({ link, name }) => (
          <Breadcrumb className="hidden first:flex last:flex desktop:flex">
            {link ? (
              <Link href={link} isDisabled={false}>
                {name}
              </Link>
            ) : (
              name
            )}
          </Breadcrumb>
        )}
      </Breadcrumbs>
    </div>
  )
}
